<template>
  <ShowTooltip no-padding>
    <template #trigger>
      <div
        :class="[
          'size-5 simulfest:landscape:size-[2.6cqh] simulfest:portrait:size-[4cqw] bg-gradient-to-b from-brand-primary to-brand-surface-hover rounded-[5px] shadow inline-flex justify-center items-center p-[2px]',
          $attrs,
          {
            'scale-80': size === 'sm',
            'scale-200': size === 'lg',
            'scale-280': size === 'xl',
          },
        ]"
      >
        <div
          class="p-[2px] w-full h-full bg-gradient-to-b from-[#f3f3f3] to-[#acd3f0] rounded-sm shadow inline-flex justify-center items-center"
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 8.3267L2.47157 9.92536C2.37732 9.98305 2.28292 10.0073 2.18835 9.9981C2.09379 9.9889 2.00821 9.95551 1.93163 9.89793C1.85493 9.84024 1.79574 9.76488 1.75403 9.67186C1.71243 9.57885 1.70577 9.47595 1.73404 9.36317L2.40527 6.35307L0.173048 4.32715C0.0896389 4.25117 0.0365063 4.16315 0.01365 4.06309C-0.00931461 3.96303 -0.00330265 3.86581 0.0316859 3.77144C0.0666744 3.67717 0.117099 3.60011 0.18296 3.54026C0.24882 3.4804 0.338837 3.44128 0.45301 3.42288L3.39887 3.15303L4.5426 0.310566C4.5842 0.204829 4.6473 0.126634 4.7319 0.07598C4.8165 0.0253262 4.90587 0 5 0C5.09413 0 5.1835 0.0253262 5.2681 0.07598C5.3527 0.126634 5.4158 0.204829 5.4574 0.310566L6.60113 3.15303L9.54699 3.42288C9.66116 3.44128 9.75118 3.4804 9.81704 3.54026C9.8829 3.60011 9.93333 3.67717 9.96831 3.77144C10.0033 3.86581 10.0093 3.96303 9.98635 4.06309C9.96349 4.16315 9.91036 4.25117 9.82695 4.32715L7.59473 6.35307L8.26595 9.36317C8.29423 9.47595 8.28757 9.57885 8.24597 9.67186C8.20427 9.76488 8.14507 9.84024 8.06837 9.89793C7.99179 9.95551 7.90621 9.9889 7.81165 9.9981C7.71708 10.0073 7.62268 9.98305 7.52843 9.92536L5 8.3267Z"
              fill="fill-black"
              class="fill-brand-primary"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1323_6635"
                x1="5"
                y1="0"
                x2="5"
                y2="10"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#5E38BD" />
                <stop offset="1" stop-color="#432AAC" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </template>
    <div
      class="p-2 bg-[#6cadde]/20 rounded shadow border border-[#6cadde]/20 justify-center items-center gap-2 flex flex-col"
    >
      <div
        class="text-center text-white text-sm font-medium font-sans leading-tight"
      >
        {{ $t("channel.premium.member") }}:
      </div>
      <div
        class="text-center text-white text-sm font-medium font-sans leading-tight"
      >
        {{ $t("channel.premium.benefits") }}
      </div>
    </div>
  </ShowTooltip>
</template>

<script lang="ts" setup>
import ShowTooltip from "@/components/show/show-tooltip.vue";

defineOptions({
  inheritAttrs: false,
});

defineProps<{
  size?: "sm" | "md" | "lg" | "xl";
}>();
</script>

<style scoped>
.scale-80 {
  transform: scale(0.8);
}
.scale-200 {
  transform: scale(2);
}
.scale-280 {
  transform: scale(2.8);
}
</style>
